module.exports = __webpack_public_path__ + "img/bank-teb.6761f4ba.svg";